import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import {
  createProfilePatientMaster,
  GET_USER_PREFERENCE_TAG,
  getProfileBasic,
  getProfilePatientMaster,
  getProfilesDetails,
  getUserPreferences,
  PROFILE_BASIC_TAGS,
  PROFILE_PATIENT_MASTER_TAGS,
  updateLoginDate,
  updateProfileBasic,
  updateProfilePatientMaster,
  updateUserPreferences,
} from './endpoints';

const userProfileApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getProfilesDetails: getProfilesDetails(builder),
      updateLoginDate: updateLoginDate(builder),
      getProfileBasic: getProfileBasic(builder),
      getProfilePatientMaster: getProfilePatientMaster(builder),
      updateProfileBasic: updateProfileBasic(builder),
      updateProfilePatientMaster: updateProfilePatientMaster(builder),
      createProfilePatientMaster: createProfilePatientMaster(builder),
      getUserPreferences: getUserPreferences(builder),
      updateUserPreferences: updateUserPreferences(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [PROFILE_PATIENT_MASTER_TAGS, PROFILE_BASIC_TAGS, GET_USER_PREFERENCE_TAG],
  });

export const {
  useGetProfilesDetailsQuery,
  useUpdateLoginDateMutation,
  useGetProfileBasicQuery,
  useGetProfilePatientMasterQuery,
  useUpdateProfileBasicMutation,
  useUpdateProfilePatientMasterMutation,
  useCreateProfilePatientMasterMutation,
  useGetUserPreferencesQuery,
  useLazyGetUserPreferencesQuery,
  useUpdateUserPreferencesMutation,
} = userProfileApi;
export { userProfileApi };
